import React, { useState, useContext, useEffect } from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { browserName, browserVersion } from "react-device-detect";

import RenapoContext from '../../context/RenapoContext';
import TimeCompContext from '../../context/TimerCompContext';
import ViewContext from '../../context/ViewContext';
import AlldataComp from '../../context/AlldataComp';
import ProspectosContext from '../../context/ProspectosContext'
import LoadingTailwindContext from '../../context/LoadingTailwindContext'
import AlertImageContext from '../../context/AlertImageContext';

import AlertComp from '../Shared/AlertComp';
import TimerComp from './TimerComp';
import LoadingTailwindComp from '../Shared/LoadingTailwindComp';

import { Setting } from '../../config';


import '../../Styles/SMSComp.css'

let Phone = false;
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
    Phone = true;
}
const ServerRoute = Setting.API_URL

function SMSComp() {

    const { register: registerSMS, formState: { errors: errorsSMS }, handleSubmit: handleSubmit_SMS, } = useFormContext();
    const [dataAlert, setdataAlert] = useState({ bool: false, label: "", variant: "" })
    const [code, setCode] = useState(0);
    const [masknumber, setmasknumber] = useState("****");

    const [dataRenapo,] = useContext(RenapoContext);
    const [dataTimeContext, setdataTimeContext] = useContext(TimeCompContext);
    const [dataAlldataComp,] = useContext(AlldataComp);
    const [, setdataView] = useContext(ViewContext);
    const [dataProspecto,] = useContext(ProspectosContext);
    const [dataLoadingTailwind, setdataLoadingTailwind] = useContext(LoadingTailwindContext);
    const [, setAlertImageData] = useContext(AlertImageContext);

    useEffect(() => {
        document.getElementById("titleFormulario").scrollIntoView();
    }, [])

    const OnKeyup = (event) => {
        const { value, name } = event.target;
        const [, fieldInex] = name.split("_");
        const refOnlynumbers = /^[0-9\b]+$/;
        value.match(refOnlynumbers);
        if (value.match(refOnlynumbers)) {
            let fieldintIndex = parseInt(fieldInex, 10);
            const nextFiel = document.querySelector(
                `input[name=field_${fieldintIndex + 1}]`
            );
            if (nextFiel !== null) {
                nextFiel.focus();
                nextFiel.value = "";
            }
        } else {
            event.target.value = ""
        }
    }
    const onSubmit = async data => {
        //alert(code);
        let codeUser = parseInt(data.field_1 + data.field_2 + data.field_3 + data.field_4);
        if (code === codeUser) {
            setdataLoadingTailwind(item => ({ ...item, success: false, save: true, email: false, thinking: false, location: false, loading: true, label: "Estamos guardando su información. Espere por favor. No recargue la página" }))
            try {
                let formData = new FormData();
                console.log(dataAlldataComp);
                formData.append("data", JSON.stringify(dataAlldataComp))
                fetch(ServerRoute + "Service/PostReclutamiento",
                    {
                        method: "post",
                        mode: 'cors',
                        body: formData
                    })
                    .then((response) => {
                        if (response.ok) {
                            return response.json();
                        }
                        else {
                            setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                            setdataAlert({ bool: true, label: "¡ Error al tratar de guardar su información, favor de intentar mas tarde!", variant: "warning" })
                        }
                    })
                    .then((responseJson) => {
                        if (responseJson.code === 200) {
                            setdataLoadingTailwind(item => ({ ...item, success: false, save: true, email: false, thinking: false, location: false, loading: true, label: "Estamos guardando sus documentos. Espere por favor. No recargue la página" }))
                            formData = new FormData();
                            formData.append("token", dataRenapo.Token)
                            formData.append("NumId", 0)
                            formData.append("fileComp", [])
                            formData.append("IdComp", 0)
                            if(dataRenapo.IDdocumento != 0){                                
                                formData.append("Id_Identif", dataRenapo.IDdocumento)

                                if (dataRenapo.IDdocumento == 1){
                                    formData.append("fileIdentif", dataProspecto.documentFront.file)
                                }
                                if (dataRenapo.IDdocumento != 5){
                                    formData.append("fileIdentif", dataProspecto.passport.file);
                                }
                                formData.append("fileIdentifBack", dataProspecto.documentReverse.file)
                            }



                            fetch(ServerRoute + "Service/PostDocumentos",
                                {
                                    method: "post",
                                    mode: 'cors',
                                    body: formData
                                })
                                .then((response) => {
                                    if (response.ok) {
                                        return response.json();
                                    }
                                    else {

                                        formData = new FormData();
                                        formData.append("Token", dataRenapo.Token)
                                        fetch(ServerRoute + "Service/DeleteData",
                                            {
                                                method: "post",
                                                mode: 'cors',
                                                body: formData
                                            })
                                        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                                        setdataAlert({ bool: true, label: "¡ Error al tratar de guardar su información files, favor de intentar mas tarde!", variant: "warning" })
                                    }
                                })
                                .then((responseJson) => {
                                    if (responseJson.code === 200) {
                                        formData = new FormData();
                                        formData.append("Correo", dataRenapo.Correo)
                                        fetch(ServerRoute + "Service/EnviarMail",
                                            {
                                                method: "post",
                                                mode: 'cors',
                                                body: formData
                                            })
                                        setAlertImageData(item => ({
                                            ...item,
                                            src: "https://webfullerette.fuller.com.mx/Content/img/Popup-rechazadas/ENPROCESO/Imagen_EnProceso.png",
                                            title: "¡ÚLTIMO PASO!, CONFIRMA TU CORREO ELECTRÓNICO",
                                            body: "Para continuar con tu proceso de inscripción te hemos enviado un correo para que concluyas tu trámite.",
                                            body2: "",
                                            bodyfotter: "¡ Revisa tu correo ahora mismo !",
                                            bool: true,
                                            scneario: "E",
                                            dataFullerette: {},
                                            dataCoordinadora: {},
                                            dataGerente: {}
                                        }))
                                        //dsdf setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))

                                    }
                                    else {
                                        formData = new FormData();
                                        formData.append("Token", dataRenapo.Token)
                                        fetch(ServerRoute + "Service/DeleteData",
                                            {
                                                method: "post",
                                                mode: 'cors',
                                                body: formData
                                            })
                                        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                                        setdataAlert({ bool: true, label: "¡ Error al tratar de guardar su información, favor de intentar mas tarde!", variant: "warning" })
                                    }
                                })
                        }
                        else {
                            setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                            setdataAlert({ bool: true, label: "¡ Error al tratar de guardar su información, favor de intentar mas tarde!", variant: "warning" })
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                        setdataAlert({ bool: true, label: "¡ Error al tratar de guardar su información, favor de intentar mas tarde!", variant: "warning" })

                    })
            }
            catch (e) {
                console.error(e);
                setdataAlert({ bool: true, label: "¡ Error al tratar de guardar su información, favor de intentar mas tarde!", variant: "warning" })
                setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
            }
        }
        else {
            setdataAlert({ bool: true, label: "¡ El código es incorrecto o ha expirado.! ", variant: "warning" })
        }
        setTimeout(() => {
            setdataAlert({ bool: false, label: "", variant: "" })
        }, 5000);
    }
    const onClickCancelar = async () => {
        setdataView('LZ');
    }
    const OnClickSMSeMAIL = async () => {

        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: true, thinking: false, location: false, loading: true, label: "Enviando Código, espere por favor" }))
        let Code = Math.floor(1000 + Math.random() * 9000);
        setCode(Code)
        setdataTimeContext({ minutes: 5, seconds: 0 })

        let Dispositivo = "Navegador Web";
        if (Phone)
            Dispositivo = "Celular";

        let formData = new FormData();
        formData.append('number_Format_API', dataRenapo.Celular);
        formData.append('codigoapi', Code);
        formData.append('Navegador', (browserName + " " + browserVersion));
        formData.append('Dispositivo', Dispositivo);

        let Jsondata = fetch(ServerRoute + "Service/API_SMS_Directo",
            {
                method: "post",
                mode: 'cors',
                body: formData
            })
        Jsondata.then(response => {
            response.json()
                .then(
                    async (result) => {
                        if (result.code === 200) {
                            setdataAlert({ bool: true, label: "¡ Código enviado exitosamente !, Ingresa el código que te enviamos por mensaje de texto para confirmar tu registro.", variant: "success" })
                        }
                        else {
                            setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
                        }
                        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                        setTimeout(() => {
                            setdataAlert({ bool: false, label: "", variant: "" })
                        }, 5000);
                    },
                )
                .catch(
                    (error) => {
                        console.error(error)
                        setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
                        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                        setTimeout(() => {
                            setdataAlert({ bool: false, label: "", variant: "" })
                        }, 5000);
                    },

                )
        })
        Jsondata.catch(async error => {
            console.error(error)
            setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
        })



        let formDataeMAIL = new FormData();
        formDataeMAIL.append('prospectName', (dataRenapo.Name + " " + dataRenapo.LastnameP));
        formDataeMAIL.append('codeAuthentication', Code);
        formDataeMAIL.append('email', dataRenapo.Correo);
        formDataeMAIL.append('phoneNumber', dataRenapo.Celular);

        let JsondataeMAIL = fetch(ServerRoute + "Service/SendCodeToEmail",
            {
                method: "post",
                mode: 'cors',
                body: formDataeMAIL
            })
        JsondataeMAIL.then(response => {
            response.json()
                .then(
                    async (result) => {
                        if (result.code === 200) {
                            setdataAlert({ bool: true, label: "¡Código enviado exitosamente!, ingresa el código que te enviamos por correo electrónico para continuar tu registro.", variant: "success" })
                        }
                        else {
                            setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
                        }
                        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                        setTimeout(() => {
                            setdataAlert({ bool: false, label: "", variant: "" })
                        }, 5000);
                    },
                )
                .catch(
                    (error) => {
                        console.error(error)
                        setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
                        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                        setTimeout(() => {
                            setdataAlert({ bool: false, label: "", variant: "" })
                        }, 5000);
                    },

                )
        })
        JsondataeMAIL.catch(async error => {
            console.error(error)
            setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
        })

        setTimeout(() => {
            setdataAlert({ bool: false, label: "", variant: "" })
        }, 5000);


    }

    useEffect(() => {
        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
    }, [setdataLoadingTailwind])

    useEffect(() => {
        const maskingPhoneNumber = () => {
            let mainStr = dataRenapo.Celular;
            let firstPart = mainStr.slice(0, 4);
            let astheriks = '';
            for (var i = 0; i < 4; i++) {
                astheriks += '*';
            }
            let lastPart = mainStr.slice(-2);
            setmasknumber(firstPart + astheriks + lastPart);
        };
        const GenerateRandomCode = async () => {
            let Code = Math.floor(1000 + Math.random() * 9000);
            setCode(Code)
            let Dispositivo = "Navegador Web";
            if (Phone)
                Dispositivo = "Celular";
            try {
                let formData = new FormData();
                formData.append('number_Format_API', dataRenapo.Celular);
                formData.append('codigoapi', Code);
                formData.append('Navegador', (browserName + " " + browserVersion));
                formData.append('Dispositivo', Dispositivo);

                fetch(`${ServerRoute}Service/API_SMS_Directo`,
                    {
                        method: "post",
                        mode: 'cors',
                        body: formData
                    }).then(response => {
                        response.json()
                            .then(
                                async (result) => {
                                    if (result.return_.code === 100) {
                                        setdataAlert({ bool: true, label: "¡Código enviado exitosamente vÍa SMS y correo electrónico!, ingresa el código que te enviamos para continuar tu registro.", variant: "success" })
                                    }
                                    else {
                                        setdataAlert({ bool: true, label: " Error al enviar código vÍa SMS", variant: "success" })
                                    }
                                },
                            )
                            .catch(
                                (error) => {
                                    console.error(error)
                                    setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
                                },
                            )
                    })
                    .catch(async error => {
                        console.error(error)
                        setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde! ", variant: "warning" })
                    })

                let formDataEmail = new FormData();
                formDataEmail.append('prospectName', (dataRenapo.Name + " " + dataRenapo.LastnameP));
                formDataEmail.append('codeAuthentication', Code);
                formDataEmail.append('email', dataRenapo.Correo);
                formDataEmail.append('phoneNumber', dataRenapo.Celular);

                let respEmail = await fetch(ServerRoute + "Service/SendCodeToEmail",
                    {
                        method: "post",
                        mode: 'cors',
                        body: formDataEmail
                    })
                respEmail = await respEmail.text();
                respEmail = await JSON.parse(respEmail);
                if (respEmail.code === 200) {
                    setdataAlert({ bool: true, label: "¡Código enviado exitosamente vÍa SMS y correo electrónico!, ingresa el código que te enviamos para continuar tu registro.", variant: "success" })
                }
                else {
                    setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
                }

                setTimeout(() => {
                    setdataAlert({ bool: false, label: "", variant: "" })
                }, 5000);
            } catch (e) {
                setdataAlert({ bool: true, label: "¡ Error al enviar código, favor de intentar mas tarde!", variant: "warning" })
                setTimeout(() => {
                    setdataAlert({ bool: false, label: "", variant: "" })
                }, 5000);
            }
        }

        maskingPhoneNumber();
        GenerateRandomCode();

    }, [dataRenapo])

    useEffect(() => {
        if (dataTimeContext.minutes === 0 && dataTimeContext.seconds === 0) {
            setCode(0)
        }
    }, [dataTimeContext, setdataTimeContext])

    useEffect(() => {
        setdataTimeContext({ minutes: 5, seconds: 0 })
    }, [setdataTimeContext])

    return (
        <div>
            {
                dataLoadingTailwind.loading ? (
                    <LoadingTailwindComp label={dataLoadingTailwind.label} />) :
                    (

                        <Container className="Container-mobile-code from_sms_new">
                            <AlertComp bool={dataAlert.bool} label={dataAlert.label} variant={dataAlert.variant} />
                            <div className='col-12 mb-4 form_subtitle text-start'>
                                <label className="font-weight-bold form_subtitle-label">Verificación telefónica</label> <br />
                            </div>
                            {/* <FontAwesomeIcon icon={faMobileAlt} className="icon-mobile" /> */}
                            <p className='from_sms_p'>
                                Por protección hemos enviado un mensaje con un código único de cuatro dígitos
                                a tu número celular {masknumber} y a tu correo {dataRenapo.Correo}
                            </p>
                            <Form key={3} onSubmit={handleSubmit_SMS(onSubmit)}>

                                <p className='from_sms_p'>Ingrese el código en esta sección</p>

                                <div className="form_sms_container-code">
                                    <input onKeyUp={OnKeyup} name="field_1" tabIndex="1" className="form_sms-code-input" type="text" maxLength="1" {...registerSMS("field_1", { required: true })} />
                                    <input onKeyUp={OnKeyup} name="field_2" tabIndex="2" className="form_sms-code-input" type="text" maxLength="1" {...registerSMS("field_2", { required: true })} />
                                    <input onKeyUp={OnKeyup} name="field_3" tabIndex="3" className="form_sms-code-input" type="text" maxLength="1" {...registerSMS("field_3", { required: true })} />
                                    <input onKeyUp={OnKeyup} name="field_4" tabIndex="4" className="form_sms-code-input" type="text" maxLength="1" {...registerSMS("field_4", { required: true })} />
                                </div>
                                {(errorsSMS.field_1?.type === 'required' || errorsSMS.field_2?.type === 'required' || errorsSMS.field_3?.type === 'required' ||
                                    errorsSMS.field_4?.type === 'required') &&
                                    <label className="mandatory">¡Dato necesario ! Favor de ingresar los 4 digítos</label>}
                                <br />
                                <label className="label-exp mt-5" >Código expira en {(dataTimeContext.minutes === 0 && dataTimeContext.seconds === 0) ? "00:00" : <TimerComp />} minutos </label>
                                <p className='from_sms_p mt-4 mb-5'>¿Aún no llega tu código? ó ¿Tu código expiró?</p>

                                <label className="label-exp from_sms_Resend" onClick={() => { OnClickSMSeMAIL(); }}>Reenviar código</label>
                                {/* 
                                <div className='from_sms_contactos'>
                                    
                                    
                                </div> */}
                                <div className='row from_sms_contactos'>
                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className='form_container_contacto'><p className='from_sms_p'>Reenviar a {masknumber}</p></div>
                                    </div>
                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className='form_container_contacto'><p className='from_sms_p'>Reenviar a {dataRenapo.Correo}</p></div>
                                    </div>
                                </div>

                                <div className='row from_sms_buttons'>
                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className='form_container_buttons'>
                                            <Button className="from_sms_footer_btn btn_cancel " variant="primary" type="" onClick={onClickCancelar}>Cancelar</Button>
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                        <div className='form_container_buttons'>
                                            <Button className="from_sms_footer_btn btn_verify " variant="primary" type="submit">Validar Código</Button>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='from_sms_buttons'>

                                </div> */}

                            </Form>
                        </Container>
                    )
            }
        </div>
    )
}

export default SMSComp;